import React from 'react';
import PureComponent from 'ROOT/src/components/pure';
import {connect} from 'react-redux';

// components shared with Aon portal
import Home from 'ROOT/views/portal/components/Home/Home';
import List from 'ROOT/views/portal/components/list/list';
import RightPanel from 'ROOT/views/portal/components/RightPanel/RightPanel';
import Detail from 'ROOT/views/portal/components/detailView/detail';
import GlobalSearch from 'ROOT/views/portal/components/GlobalSearch/GlobalSearch';
import PortalAdminContainer from 'ROOT/views/portal/components/admin/PortalAdminContainer';

// Modified Ern components
import Login from './login/login';
import Header from './Header/Header';
import Custom from './custom/custom';
import Error404 from './custom/Error404';

// Standart shared components
import Popup from 'ROOT/src/components/popup/popup';
import ErrorController from 'ROOT/src/components/Errors/ErrorController';
import ErrorView from 'ROOT/src/components/Errors/ErrorView';
import Loader from 'ROOT/src/components/loader';
import Popper from 'ROOT/src/components/popper/Popper';
import Toast from 'ROOT/src/components/Toast/Toast';
import ReportContainer from 'ROOT/src/components/CustomReport/ReportContainer';
import Admin from 'ROOT/src/components/admin/admin';

// Custom modified Ern css
import '../sass/index.sass';
import '../less/index.less';

class App extends PureComponent {
    render() {
        const store = this.props.store;
        const conf = store.appReducer.conf;
        const hash = window.location.hash;
        let recordName = null;
        if (conf.view == 'detail' || conf.view == 'leadConvert') {
            recordName = store.appReducer.view.name;
        }
        const routeData = {
            detail: (
                <Detail
                    key="detail"
                    a={this.props.action}
                    data={store.appReducer.view}
                    way="view"
                />
            ),
            list: <List key="list" data={store.appReducer.view} way="view" />,
            home: <Home key="home" data={store.appReducer.view} way="view" />,
            globalSearch: (<GlobalSearch data={store.appReducer.view} way="view" />),
            portalAdmin: (<PortalAdminContainer data={store.appReducer.view} way="view" />),
            customReports: <ReportContainer data={store.appReducer.view} way="view" />,
            error: <ErrorView data={store.appReducer.view} />,
            admin: <Admin
                data={store.appReducer.view}
                back_version={conf.back_version}
                front_version={conf.front_version}
                way="view"
            />,
        };
        let page = null;
        if (conf.view == 'login') {
            page = <Login key="login" version={conf.front_version} redirect={conf.redirect} />;
        } else if (conf.view == 'custom') {
            page = <Custom data={store.appReducer.view} way="view" />;
        } else if (conf.view == 'error404') {
            page = <Error404 />;
        } else {
            let content = null;
            if (conf.view != '') {
                content = routeData[conf.view];
            } else if (conf.view == '' && conf.load == false) {
                content = routeData['home'];
            }

            let pageClass = '';
            const alertMessageOpen = conf.alertMessage.get('show');
            if (store.appReducer.menu.open == false) {
                pageClass += ' min';
            }
            if (alertMessageOpen) {
                pageClass += ' alertMessageActive';
            }
            page = (
                <React.Fragment>
                    <Header key="header" data={store.appReducer.view} alertMessage={conf.alertMessage} user={conf.user} not={store.appReducer.notifications}
                        hash={hash}
                        recordName={recordName}
                    />

                    <div
                        key="viewContainer"
                        id="page"
                        className={pageClass}
                    >
                        {content}
                    </div>
                    {store.appReducer.rightPanel.show && (
                        <RightPanel data={store.appReducer.rightPanel} conf={conf}/>
                    )}
                </React.Fragment>
            );
        }
        let Container = React.Fragment;
        // eslint-disable-next-line no-undef
        if (DEVMODE == true) {
            Container = ErrorController;
        }
        return (
            <Container>
                <div className="acmMaterial portal">
                    {page}
                    {conf.popup.show && (
                        <Popup
                            reportWindow={store.appReducer.reportWindow}
                            data={conf.popup}
                            way={'conf/popup'}
                            calProps={{}}
                        />
                    )}
                    {conf.popup2.show && (
                        <Popup
                            reportWindow={store.appReducer.reportWindow}
                            way={'conf/popup2'}
                            data={conf.popup2}
                        />
                    )}
                    {conf.popper.size > 0 &&
            <Popper data={conf.popper} />
                    }
                    {conf.toast.size > 0 &&
            <Toast data={conf.toast} />
                    }
                    {conf.load == true && (
                        <Loader fullscreen />
                    )}
                </div>
                <div className="menuHoverLabel"></div>
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        store: state,
    };
};

export default connect(mapStateToProps)(App);
